import React, {Component} from "react";
import { Outlet } from "react-router-dom";
import Sidebar from './Components/Bar/Sidebar';
import Topbar from './Components/Bar/Topbar';
import Footer from "./Components/Bar/Footer";
import logo from "../src/assets/assets_theme/img/ubtlogo.jpg"

export default class Container extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //       nb_click: 0,
    //       pathname: "/",
    //     }
    //   }

    //   componentWillMount() {
    //    setInterval(() => {
    //     if (this.state.pathname !== window.location.pathname) {
    //         this.setState({pathname: window.location.pathname});
    //     }
    //    }, 100);
    //   }
    componentDidMount() {
      document.title = "UBT Cambodia";
      // Set the favicon
      const favicon = document.createElement("link");
      favicon.rel = "icon";
      favicon.type = "image/png"; // or "image/x-icon" for .ico files
      favicon.href = {logo}; // Replace with the actual path to your favicon
      document.head.appendChild(favicon);
    }

      render() {
        return <div  className="App">
          <Sidebar />      
          <Topbar />

          
          <main className="main-container">
              <div className="main-content">
                  <div className="row">
                  <Outlet />
                  </div>
              </div>
              <Footer />
          </main>
          
        </div>
  
      }
}